/*
 * Copyright (c) 2026 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, July 5th 2026, 10:37:46 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import FormControl from "@mui/material/FormControl";
import { CronExpressionInput } from "./CronExpressionInput";
import { ISO8601IntervalInput } from "./ISO8601IntervalInput";
import { EventConfigurationData, TimerExpressionType } from "lib/schemas";
import { OSDropDown } from "ui-widgets";

type TimerEventConfigurationInputProps = {
  configuration: EventConfigurationData;
  setValue: (configuration_field_name: keyof EventConfigurationData, value: any) => void;
};

const TimerEventConfigurationInput = ({ configuration, setValue }: TimerEventConfigurationInputProps) => {
  const isISO8601Expression = configuration?.timer_expression_type === "iso_8601";
  const isCRONExpression = configuration?.timer_expression_type === "cron";
  return (
    <FormControl>
      <OSDropDown
        options={{ task_created: "Task Created", task_started: "Task Started", task_assigned: "Task Assigned" }}
        label="Countdown from?"
        onChangeCallBack={(value) => setValue("timer_countdown_from", value as any)}
        value={configuration?.timer_countdown_from}
      />
      <OSDropDown
        options={TimerExpressionType}
        label="Timer Expression Type"
        onChangeCallBack={(value) => setValue("timer_expression_type", value as any)}
        value={configuration?.timer_expression_type}
      />
      {isISO8601Expression && (
        <ISO8601IntervalInput
          label="Timer Expression (In ISO 8601 Format)"
          setValue={(value) => setValue("timer_expression", value as any)}
          value={configuration.timer_expression}
        />
      )}
      {isCRONExpression && (
        <CronExpressionInput
          label="Cron Expression"
          setValue={(value) => setValue("timer_expression", value)}
          value={configuration.timer_expression}
        />
      )}
    </FormControl>
  );
};

export { ISO8601IntervalInput, CronExpressionInput, TimerEventConfigurationInput };
